import dayjs from 'dayjs';

export const isTicketAvailable = (ticket) => {
    if (ticket.remainingQuantity <= 0) return false;
    const now = dayjs();
    if (ticket.saleStart && now.isBefore(dayjs(ticket.saleStart))) return false;
    if (ticket.saleEnd && now.isAfter(dayjs(ticket.saleEnd))) return false;
    return true;
};

const formatPln = (value) =>
    `${value.toFixed(2).replace('.', ',')} zł`;

// Cena do opisu wydarzenia: jedna cena → konkretna kwota, kilka różnych → „Od … zł”
export const getPriceLabel = (event, t, lang) => {
    const en = (lang || '').startsWith('en');
    if (event?.isFree) return t('event.ticket.free');
    const all = event?.ticketTypes || [];
    if (all.length === 0) return t('no_tickets');
    const available = all.filter(isTicketAvailable);
    const source = available.length ? available : all;
    const gross = [...new Set(source.map(tk => Number((tk.price * (1 + (tk.vatPercentage || 0) / 100)).toFixed(2))))];
    const min = Math.min(...gross);
    const price = gross.length === 1 ? formatPln(min) : `${en ? 'From' : 'Od'} ${formatPln(min)}`;
    return available.length ? price : `${price} · ${t('ticket.sold')}`;
};
